import { AccountView } from '.';

export const score = Symbol('score');

export interface ScoredAccountView extends AccountView {
  [score]: number;
}

export default ScoredAccountView;
